import { task } from 'ember-concurrency';
import { defaultErrorHandler } from 'volta/utils/error-utils';

import Service, { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';

import type { TError } from 'volta/utils/error-utils';
import type StoreService from './store';
import type Owner from '@ember/owner';

export interface TPermissionsByEntity {
  [entityType: string]: string[];
}

export default class PermissionsCacheService extends Service {
  @service store!: StoreService;

  @tracked permissions: string[] = [];
  @tracked permissionsByEntity: TPermissionsByEntity = {};

  constructor(owner: Owner) {
    super(owner);
    this.task.perform();
  }

  promise() {
    return this.task.perform();
  }

  task = task(async () => {
    try {
      if (this.permissions.length > 0) {
        return this.permissions;
      }

      const permissions = (await this.store.normalGet('userRoles/permissions')) as string[];
      this.permissions = permissions;
      return permissions;
    } catch (error) {
      return defaultErrorHandler(error as TError);
    }
  });

  fetchPermissionsByEntity = task(async () => {
    try {
      const permissions = await this.store.normalGet<TPermissionsByEntity>('userRoles/permissionsByEntity');
      this.permissionsByEntity = permissions;
      return permissions;
    } catch (error) {
      return defaultErrorHandler(error as TError);
    }
  });
}

declare module '@ember/service' {
  interface Registry {
    'permissions-cache': PermissionsCacheService;
  }
}
